import ConfirmActionModal from "components/common/ConfirmActionModal";
import type { PayrollRun } from "features/Payroll/types/payroll.types";
import { finalizePayrollRunWithFeedback } from "features/Payroll/utils/finalizePayrollRunAction";
import React, { useState } from "react";
import { toast } from "react-toastify";

type FinalizePayrollRunConfirmModalProps = {
  run: PayrollRun | null;
  isOpen: boolean;
  onClose: () => void;
  onFinalized?: () => void | Promise<void>;
};

const FinalizePayrollRunConfirmModal = ({
  run,
  isOpen,
  onClose,
  onFinalized,
}: FinalizePayrollRunConfirmModalProps) => {
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    if (!run) return;
    setBusy(true);
    try {
      const { ok, message } = await finalizePayrollRunWithFeedback(run.id);
      if (ok) {
        onClose();
        toast.success(message);
        await onFinalized?.();
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmActionModal
      show={isOpen && run != null}
      iconClass="ri-check-double-line"
      iconColor="text-success"
      heading="Finalize this payroll run?"
      description={
        run
          ? `You are about to finalize payroll run ${run.code ?? `#${run.id}`}. After finalizing, this run is typically locked for editing.`
          : undefined
      }
      confirmText={busy ? "Finalizing…" : "Finalize run"}
      confirmDisabled={busy}
      cancelText="Cancel"
      onConfirm={() => void handleConfirm()}
      onClose={onClose}
    />
  );
};

export default FinalizePayrollRunConfirmModal;
